import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import elements from '../../JSON/sliderElements.json';
import Container from '../Container/Container';

import s from './sliderComponent.module.css';

export default function SliderComponent() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };
  return (
    <>
      <section className={s.section}>
        <Container>
          <h2 className={s.title}>Продукція</h2>
          <div className={s.container}>
            <Slider {...settings}>
              {elements.map(element => (
                <Link className={s.link} to={`${element.category}`}>
                  <div className={s.wrapper}>
                    <img
                      src={element.imageSrc}
                      alt={elements.category}
                      className={s.image}
                    />
                  </div>
                  <p className={s.text}>{element.title}</p>
                </Link>
              ))}
            </Slider>
          </div>
        </Container>
      </section>
    </>
  );
}
